"use client";
import createClient from "openapi-fetch";
import { paths } from "@/api/schema"; // (generated from openapi-typescript)

export const {
  GET: get,
  POST: post,
  PUT: put,
  PATCH: patch,
  DELETE: del,
} = createClient<paths>({
  baseUrl: process.env.BASE_API_URL,
  mode: "cors",
});
